import React from 'react';
import SupportTicketContain from '../../Componant/SupportTicket';

const SupportTicket = () => {
  return (
    <div className='page-body'>
      <SupportTicketContain />
    </div>
  );
};

export default SupportTicket;
